import React from 'react'
import {NavLink} from 'react-router-dom'

const Navbar = () => {
  return (
    <div className='navbar'> 
        <NavLink to="/customer/" className={`navItem mb-4 ${(navData) => (navData.isActive ? 'active' : '')}`}>
          <div className='title'>Dashboard</div>

          <div className='iconCircle ms-auto me-2 d-none d-lg-block'></div>
        </NavLink>

        <NavLink to="/customer/sr-request" className={`navItem mb-4 ${(navData) => (navData.isActive ? 'active' : '')}`}>
          <div className='title'>Service Request</div>
          
          <div className='iconCircle ms-auto me-2 d-none d-lg-block' ></div>
        </NavLink>

        <NavLink to="/customer/offers" className={`navItem mb-4 ${(navData) => (navData.isActive ? 'active' : '')}`}>
          <div className='title'>Offers</div>
        
          <div className='iconCircle ms-auto me-2 d-none d-lg-block'></div>
        </NavLink>

        <NavLink to="/customer/account" className={`navItem mb-4 ${(navData) => (navData.isActive ? 'active' : '')}`}>
          <div className='title'>Account</div>
          
          <div className='iconCircle ms-auto me-2 d-none d-lg-block'></div>
        </NavLink>
    </div>
  )
}

export default Navbar